
import { RefreshCw } from 'lucide-react';

interface FeedHeaderProps {
  onRefresh: () => void;
  isRefreshing: boolean;
  isLoading: boolean;
}

const FeedHeader = ({ onRefresh, isRefreshing, isLoading }: FeedHeaderProps) => {
  return (
    <div className="flex items-center justify-between mb-6">
      <h1 className="text-2xl font-bold">Your Feed</h1>
      <button 
        onClick={onRefresh}
        disabled={isRefreshing || isLoading}
        className="p-2 rounded-full hover:bg-gray-200 dark:hover:bg-gray-800 transition-colors disabled:opacity-50 transform hover:scale-110 active:scale-95"
      >
        <RefreshCw className={`w-5 h-5 ${isRefreshing ? 'animate-spin' : ''}`} />
      </button>
    </div>
  );
};

export default FeedHeader;
